const newsletter = {
  page: {
    title: 'Kostenfreien Newsletter abonnieren',
  },
  forms: {
    salutation: 'Anrede',
    firstName: 'Vorname *',
    lastName: 'Nachname *',
    email: 'E-Mail-Adresse *',
    policy: {
      termsOfUse: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzbestimmungen',
      1: 'Die',
      2: 'und',
      3: 'habe ich zur Kenntnis genommen und bin mit ihrer Geltung einverstanden.',
    },
    pleaseFill: '* Bitte füllen Sie die Pflichtfelder aus',
    subscribe: 'Abonnieren',
    newHere: 'Neu hier?',
    join: 'Jetzt registrieren',
    forgotPassword: 'Passwort vergessen?',
    error: 'Sie sind bereits für diesen Newsletter angemeldet.',
    successTitle: 'Ihre Newsletter Anmeldung',
    successText: 'Herzlichen Dank für Ihre Anmeldung zum kostenfreien Newsletter von IhreApotheken. Sie haben soeben eine Bestätigungs-E-Mail erhalten.',
    button: 'Zur Startseite',
  },
}

export default newsletter
